import React, { useEffect, useState } from "react";
import { APIProvider, Map, AdvancedMarker, InfoWindow, Pin } from "@vis.gl/react-google-maps";
import { useTranslation } from "react-i18next";

const MyMap = () => {
  const { t, i18n } = useTranslation();
  const [place, setPlace] = useState(null);
  const [infoOpen, setInfoOpen] = useState(false);

  // Центр карты — координаты Баку
  const bakuCoords = {
    lat: 40.371664889764624,
    lng: 49.849220850213804
  };

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("lng") || "en");
    setPlace({
      name: "FinManagement, SARDA Group",
      address: "Azadlıq prospekti 1",
      coords: bakuCoords
    });
  }, [i18n]);

  const handleCameraChanged = (ev) => {
    console.log("Камера изменилась:", ev.detail.center, "Zoom:", ev.detail.zoom);
  };

  return (
    <div className="z-30 mt-3" style={{ height: "300px", width: "100%" }}>
      <APIProvider apiKey="AIzaSyDFgEI3IvHqcZ1ObvH_i6jVD6GL_GOaWBw">
        {place ? (
          <Map
            defaultZoom={16}
            defaultCenter={place.coords}
            onCameraChanged={handleCameraChanged}
            style={{ width: "100%", height: "100%", borderRadius: "12px" }}
            mapId="YOUR_MAP_ID" // Добавьте ваш mapId для кастомного стиля (опционально)
          >
            <AdvancedMarker
              position={place.coords}
              onClick={() => setInfoOpen(true)}
            >
              <Pin background="#4285F4" borderColor="#3367D6" glyphColor="#FFF" />
            </AdvancedMarker>

            {infoOpen && (
              <InfoWindow
                position={place.coords}
                onCloseClick={() => setInfoOpen(false)}
              >
                <div className="text-sm">
                  <strong>{place.name}</strong>
                  <p>{place.address}</p>
                  <a
                    className="text-blue-500 underline"
                    href={`https://www.google.com/maps/dir/?api=1&destination=${place.coords.lat},${place.coords.lng}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("Get directions")}
                  </a>
                </div>
              </InfoWindow>
            )}
          </Map>
        ) : (
          <div>Loading map...</div>
        )}
      </APIProvider>
    </div>
  );
};

export default MyMap;